"use client";

import { SectionTitle } from "./sectionTitle";
const PrizeCard = (props: {
	prize: string;
	supplementaryPrize?: string;
	imgSrc?: string;
}) => {
	return (
		<div className={"flex flex-col  max-w-4xl font-bold"}>
			{props?.imgSrc && (
				<img src={props.imgSrc} className={"w-xl h-auto"} alt={props.prize} />
			)}
			<p>【{props.prize}】</p>
			{props?.supplementaryPrize ? (
				<p>賞状 + 副賞「{props.supplementaryPrize}」</p>
			) : (
				<p>賞状</p>
			)}
		</div>
	);
};

export const Prizes = () => {
	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="賞品" />

			<div className={"grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16"}>
				<PrizeCard
					prize={"最優秀賞"}
					supplementaryPrize={"Amazonギフト券5万円分"}
					imgSrc={"/events/suzuka2024/prize/1.svg"}
				/>
				<PrizeCard
					prize={"協賛企業賞"}
					supplementaryPrize={"協賛企業賞"}
					imgSrc={"/events/suzuka2024/prize/q.svg"}
				/>
				<PrizeCard
					prize={"Prossell賞"}
					supplementaryPrize={"技術系の本"}
					imgSrc={"/events/suzuka2024/prize/3.svg"}
				/>
				<PrizeCard prize={"ギイクで賞"} />
				<PrizeCard prize={"チャレンジ賞"} />
				<PrizeCard prize={"オーディエンス賞"} />
			</div>
		</div>
	);
};
